module.exports = __webpack_public_path__ + "assets/urg-alt.a2c9d93f.svg";